module.exports = __webpack_public_path__ + "static/img/user-flow.3d94e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-flow.png
// module id = mpgY
// module chunks = 1